const TripAdvisorCircle = ({ type = 'full', ...props }) => (
  <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    {type === 'full' && <circle cx={8} cy={8} r={8} fill="#00AA6C" />}
    {type === 'halfFull' && (
      <>
        <path d="M8 16A7.999 7.999 0 118 0v16z" fill="#00AA6C" />
        <circle
          cx={8}
          cy={8}
          r={7}
          transform="rotate(90 8 8)"
          stroke="#00AA6C"
          strokeWidth={2}
        />
      </>
    )}
    {type === 'empty' && <circle cx={8} cy={8} r={7} stroke="#00AA6C" strokeWidth={2} />}
  </svg>
)

export default TripAdvisorCircle
